import { render, staticRenderFns } from "./LogoFlagAnimated.vue?vue&type=template&id=9131ac46"
import script from "./LogoFlagAnimated.vue?vue&type=script&lang=js"
export * from "./LogoFlagAnimated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9131ac46')) {
      api.createRecord('9131ac46', component.options)
    } else {
      api.reload('9131ac46', component.options)
    }
    module.hot.accept("./LogoFlagAnimated.vue?vue&type=template&id=9131ac46", function () {
      api.rerender('9131ac46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/branding/LogoFlagAnimated.vue"
export default component.exports